import React from 'react';
import { isEmpty, kebabCase } from 'lodash';
import BoxedContainer from '../layouts/BoxedContainer';
import Button from '../layouts/Button';

export default function ParkingInfo({ data }) {
  const { parkingInfoTitle, parkingInfoText, parkingInfoHtmlText, parkingInfoButton } = data;
  return (
    <section
      id={kebabCase(parkingInfoTitle)}
      className="lg:pt-[155px] pt-[90px] lg:pb-[238px] pb-[90px] clip-right-top bg-bg-11 relative
      z-5">
      <BoxedContainer className="regular">
        <div className="lg:max-w-[971px] flex flex-col lg:gap-y-[39px] gap-y-[20px]">
          <h3
            className="text-black font-roboto-condensed-bold lg:text-[38px] text-[30px]
            leading-[23px] uppercase">
            {parkingInfoTitle}
          </h3>
          <p className="lg:text-base text-[15px] leading-7 font-roboto-regular text-primary">
            {parkingInfoText}
          </p>
          <div
            dangerouslySetInnerHTML={{ __html: parkingInfoHtmlText }}
            className="lg:text-base text-[15px] leading-7 text-primary font-roboto-regular
            p-child:font-roboto-bold flex flex-col gap-y-2 ul-child:flex ul-child:flex-col
            ul-child:gap-y-2 li-child:flex li-child:flex-row li-child:gap-x-[10px]
            li-child-span:md:w-[22%] li-child-span:w-[54%] "
          />
          {isEmpty(parkingInfoButton) || (
            <Button
              label={parkingInfoButton.name}
              url={parkingInfoButton.url}
              ariaLabel={parkingInfoButton.name}
              tagName={kebabCase(parkingInfoButton.name)}
              target={parkingInfoButton.target}
              variant="primaryRed"
              text="max-w-fit"
            />
          )}
        </div>
      </BoxedContainer>
    </section>
  );
}
